var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rph-products-grid",class:{
    'rph-products-grid--cart': _vm.isDeliveryPage,
    'rph-products-grid--thank-you': _vm.isThankYouPage,
  }},[_vm._l((_vm.nearestProducts),function(product){return [_c('RPHProductCard',{key:product.id,attrs:{"product-data":product,"additionalKey":_vm.additionalKey}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }